import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _notificationConfig = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _resolveNotificationConfigRequest = {};
var _resolveNotificationConfigResponse = {
    notificationConfig: '_notificationConfig',
};
var _triggerNotificationRequest = {};
var _triggerNotificationResponse = {};
var _upsertNotificationConfigRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    notificationConfig: '_notificationConfig',
};
var _upsertNotificationConfigResponse = {
    notificationConfig: '_notificationConfig',
};
function resolveWixEventsNotificationsV2NotificationConfigManagementUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/events-notifications',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-notifications',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-notifications',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events-notifications',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsNotificationsV2NotificationServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/events-notifications',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-notifications',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-notifications',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events-notifications',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Triggers notification */
export function triggerNotification(payload) {
    var _a = serializer(_triggerNotificationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerNotificationResponse, {}).fromJSON;
    function __triggerNotification(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.notifications.v2.notification_config',
            method: 'POST',
            methodFqn: 'wix.events.notifications.v2.NotificationService.TriggerNotification',
            url: resolveWixEventsNotificationsV2NotificationServiceUrl({
                protoPath: '/v2/notifications/trigger',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerNotification.fromReq = fromReq;
    __triggerNotification.__isAmbassador = true;
    return __triggerNotification;
}
/** Resolves a NotificationConfig by id. Returns saved value or default value if not saved yet. */
export function resolveNotificationConfig(payload) {
    var _a = serializer(_resolveNotificationConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveNotificationConfigResponse, {
        _notificationConfig: _notificationConfig,
    }).fromJSON;
    function __resolveNotificationConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.notifications.v2.notification_config',
            method: 'GET',
            methodFqn: 'wix.events.notifications.v2.NotificationConfigManagement.ResolveNotificationConfig',
            url: resolveWixEventsNotificationsV2NotificationConfigManagementUrl({
                protoPath: '/v2/notification-configs/resolve/{notificationConfigId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveNotificationConfig.fromReq = fromReq;
    __resolveNotificationConfig.__isAmbassador = true;
    return __resolveNotificationConfig;
}
/** Upsert a NotificationConfig */
export function upsertNotificationConfig(payload) {
    var _a = serializer(_upsertNotificationConfigRequest, { _notificationConfig: _notificationConfig }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertNotificationConfigResponse, {
        _notificationConfig: _notificationConfig,
    }).fromJSON;
    function __upsertNotificationConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.notifications.v2.notification_config',
            method: 'POST',
            methodFqn: 'wix.events.notifications.v2.NotificationConfigManagement.UpsertNotificationConfig',
            url: resolveWixEventsNotificationsV2NotificationConfigManagementUrl({
                protoPath: '/v2/notification-configs/{notificationConfig.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertNotificationConfig.fromReq = fromReq;
    __upsertNotificationConfig.__isAmbassador = true;
    return __upsertNotificationConfig;
}
//# sourceMappingURL=http.impl.js.map